/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneAffiliateItem from 'base/components/standalone/AffiliateItem';

export const DynamicStandaloneAffiliateItem = StandaloneAffiliateItem;
export type DynamicStandaloneAffiliateItemProps = PropsFromComponent<typeof StandaloneAffiliateItem>;

export const DynamicStandaloneAffiliateItemWith = (extras: DynamicStandaloneExtras): typeof StandaloneAffiliateItem => {
    return function DynamicStandaloneAffiliateItem(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'AffiliateItem');
        return <StandaloneAffiliateItem {...mergeProps({ options: { theme } }, props)} />;
    }
}